import * as actionTypes from "../actions/types";
import produce from "immer";

const initialState = {
  isMobileProfile: false,
};

let newData = [];
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  console.log("mobileProfileViewReducer", payload);
  switch (type) {
    case actionTypes.OPEN_MOBILE_PROFILE_VIEW:
      draft.isMobileProfile = true;
      return draft;
    case actionTypes.CLOSE_MOBILE_PROFILE_VIEW:
      draft.isMobileProfile = false;
      return draft;
    default:
      return draft;
  }
});
